/**
 * Mirrors backend `OauthCustomerScope` (src/constants/oauth.constants.ts in withpara/para-node),
 * which is marked "Deprecated: will be removed when customers will migrate to API keys".
 * Treat these four values as frozen.
 */
export enum OAuthScope {
  Contractor = 'customer.contractor',
  Template = 'customer.template',
  Market = 'customer.market',
  Webhook = 'customer.webhook',
}
